import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import './UniversalPartsNavbar.scss';
import SortBy from 'components/SortBy/SortBy';


type Props = {
  title: string;
  option?: ReactElement
  showSortBy?: boolean
}
const UniversalPartsNavbar: React.FC<Props> = (props) => {
  const { t } = useTranslation();

  return (
    <div className="universal-parts-navbar-container">
      <div className="breadcrumbs">
        {t(props.title)}
      </div>
      {props.showSortBy ? <SortBy /> : null}
      <div className="options">{props.option}</div>
    </div>
  );
};


export default UniversalPartsNavbar;